import React from "react";
import { useSelector } from "react-redux";
import styles from "./FlooringTypesMenu.module.css";
import flooring from './assets/flooring.png';

const FlooringTypesMenu = ({handleTypeSelect}) => {
  const flooringTypes = useSelector((state) => state.visualizer.flooringTypes);

  const types =
    flooringTypes && flooringTypes.length ? (
      flooringTypes.map((obj, index) => (
        <div key={index} onClick={() => handleTypeSelect(obj)}>
          <div>
            <img src={obj.image} alt={`${obj.title}`} />
          </div>
          <div>
            <h4>{obj.title}</h4>
            <p>{obj.subTitle}</p>
          </div>

        </div>
      ))
    ) : (
      <p>No types available</p>
    );

  return (
    <>
      <div className={styles.heading}>
      <img src={flooring} alt="flooring icon" height="25" width="auto"/>
        <h3>Our Flooring</h3>
      </div>
      <div className={styles.flooringTypesMenu}>
        {types}
      </div>
    </>
  );
};

export default FlooringTypesMenu;
